import { Component, Input, OnInit } from '@angular/core';
import { LocalizePipe } from '@lf-web-components/lf-common-utils-library';
import { TableViewModel } from '../organizer-table/organizer-table.component';
import { ColumnModel, DocumentOrganizerType, EmptyPropertyKey, FileSetEntryViewModel, InitErrors } from '../shared/fs.model';
import { lfFilesetLocalize } from '../shared/utils';

@Component({
  selector: 'fileset-print',
  templateUrl: './fileset-print.component.html',
  styleUrls: ['./fileset-print.component.css', '../global-styles.css']
})
export class FilesetPrintComponent implements OnInit {
  @Input() docResources: FileSetEntryViewModel[];
  @Input() docTypes: DocumentOrganizerType[];
  @Input() docStatuses: any[];
  @Input() docColumns: ColumnModel[];
  @Input() initError: InitErrors = InitErrors.NONE;
  @Input() width: number;

  lfFilesetLocalizeHelper = lfFilesetLocalize;
  docTotal: number;
  statusTable = {};
  viewModel: TableViewModel = {
    columns: [], 
    types: []
  };

  get initErrorMsg(): string {
    switch(this.initError) {
      case InitErrors.RESOURCE_DELETED:
        return this.localizePipe.transform('lf_fileset_deleted_message', this.lfFilesetLocalizeHelper);
      case InitErrors.RESOURCE_NOT_FOUND:
        return this.localizePipe.transform('lf_fileset_not_found_message', this.lfFilesetLocalizeHelper);
      case InitErrors.NONE_INITIALIZED:
        return this.localizePipe.transform('lf_fileset_no_fileset_message', this.lfFilesetLocalizeHelper);
      case InitErrors.REJECT_PUBLIC_USERS:
        return this.localizePipe.transform('lf_fileset_reject_public_user_message', this.lfFilesetLocalizeHelper);
      default: 
        return "";
    }
  }

  constructor(
    private localizePipe: LocalizePipe
  ) { }

  ngOnInit(): void {
    this.viewModelPreprocess();
  }

  ngOnChanges() {
    this.viewModelPreprocess();
  }

  viewModelPreprocess() {
    this.docTotal = this.docResources.length;
    this.viewModel = this.processData();
  }

  processData(): TableViewModel {
    this.docStatuses.forEach(status =>{
      this.statusTable[status.key] = status;
    });

    let tModel = [];
    let tTable = {
      [EmptyPropertyKey.Type]: []
    };
    
    this.docTypes.forEach(type =>{
      tTable[type.key] = [];

      tModel.push({
        name: type.display, 
        id: type.key,
        min: type.min,
        max: type.max,
        files: []
      });
    });

    tModel.push({
      name: this.localizePipe.transform('lf_fileset_none_type', this.lfFilesetLocalizeHelper), 
      files: [], 
      id: EmptyPropertyKey.Type
    });

    this.docResources.forEach(doc =>{
      if (doc.docType in tTable) {
        tTable[doc.docType].push(doc);
      }
      else 
      {
        tTable[EmptyPropertyKey.Type].push(doc);
      }
    });

    tModel.forEach(m =>{
      m.files = tTable[m.id]
    });

    return {
      columns: this.docColumns, 
      types: tModel
    };
  }

  getStatusDisplay(key: string) {
    var status = this.statusTable[key];
    if (status) {
      return status.display;
    } 
    else 
    {
      return "";
    }
  }

  hasInitError(): boolean {
    return this.initError != InitErrors.NONE;
  }
  
  isTypeRequired(typeKey): boolean {
    let type = this.docTypes.find(x => x.key == typeKey);
    return type === undefined ? false : type.isRequired();
  }

  isLastFile(files, idx): boolean {
    if (idx === files.length - 1) {
      return true;
    }
    return false;
  }

}
